import {omitBy} from 'lodash-es';

export function normalizeNumberEnum<TEnum extends object>(enumObject: TEnum) {
  return omitBy(enumObject, (v, k) => !Number.isNaN(+k!));
}
